<template>
  <div>
    <div class="signup__main">
      <div class="signup__col1">
        <div class="signup__col1Body">
          <div class="signup__back" @click="onLogin">
            <img :src="require('../../assets/svg/back1.svg')" alt="back" />
          </div>

          <div class="signup__header">
            <img
              :src="require('../../assets/photos/khaanpinRed.png')"
              alt="khaanpin"
            />
            <div class="signup__subHeader">
              <span> FOODS . LIQUORS . CAKES</span>
              <span> 24 HOURS</span>
            </div>
          </div>

          <form class="signup__body" @submit="handleSubmit">
            <div class="signup__input">
              <font-awesome-icon icon="user" :style="{ marginLeft: '10px' }" />
              <input
                placeholder=" First Name"
                autocomplete="off"
                v-model="first_name"
                required
              />
            </div>
            <!-- <p :style="{ color: 'red' }" v-if="boolfirstnameError">hello</p> -->

            <div class="signup__input">
              <font-awesome-icon icon="user" :style="{ marginLeft: '10px' }" />
              <input
                placeholder="Last Name"
                type="text"
                autocomplete="off"
                v-model="last_name"
                required
              />
            </div>

            <div class="signup__input">
              <font-awesome-icon icon="phone" :style="{ marginLeft: '10px' }" />
              <input
                placeholder="Phone No"
                type="number"
                autocomplete="off"
                v-model="phone"
                required
              />
            </div>

            <div class="signup__input">
              <font-awesome-icon
                icon="envelope"
                :style="{ marginLeft: '10px' }"
              />
              <input
                placeholder="Email Address"
                autocomplete="off"
                v-model="email"
                required
              />
            </div>

            <div class="signup__input">
              <font-awesome-icon
                icon="location-arrow"
                :style="{ marginLeft: '10px' }"
              />
              <input
                placeholder="Primary Delivery Address"
                autocomplete="off"
                v-model="address"
                required
              />
            </div>

            <div class="signup__input">
              <font-awesome-icon icon="lock" :style="{ marginLeft: '10px' }" />
              <input
                placeholder="Password"
                type="password"
                autocomplete="off"
                v-model="password"
                required
              />
            </div>

            <button type="submit">Sign Up</button>
          </form>
          <div class="signup__loc">
            <span> Kathmandu </span>
            <span> /</span>
            <span> Pokhara</span>
          </div>
        </div>
      </div>

      <div class="signup__col2">
        <img :src="require('../../assets/photos/pizza.jpg')" alt="khaanpin" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { TokenService, TokenServiceApp } from "../../services/storage.service";

import router from "../../router";

export default {
  name: "Login",
  data() {
    return {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      password: "",
      address: "",

      firstnameError: "",
      boolfirstnameError: this.first_name.length == 0 ? true : false,

      lastnameError: "",
      boollastnameError: false,

      phoneError: "",
      boolphoneError: false,

      emailError: "",
      boolemailError: false,

      passwordError: "",
      boolpasswordError: false,

      addressError: "",
      booladdresError: false,
    };
  },
  computed: {
    ...mapGetters(["getRegisterResponse"]),
  },
  created() {
    const loggedIn = TokenService.getToken() ? true : false;
    const loggedInApp = TokenServiceApp.getToken() ? true : false;

    if (loggedInApp || loggedIn == true) {
      router.push("/");
    }
  },
  watch: {
    getRegisterResponse: function (e) {
      if (e.error) {
        this.$notification.error({
          message: "Register failed",
          description: e.data,
        });
      } else {
        this.$notification.success({
          message: "Welcome " + e.data.first_name,
          description:
            "Thanks for being the member of Khaanpin family. Login to continue.",
        });
      }
    },
  },
  methods: {
    ...mapActions(["register"]),

    onLogin() {
      router.push("/p/login");
    },

    handleSubmit(e) {
      e.preventDefault();
      const value = {
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone,
        email: this.email,
        password: this.password,
        address: this.address,
      };

      if (
        this.first_name &&
        this.last_name &&
        this.phone &&
        this.email &&
        this.password &&
        this.address
      ) {
        this.register(value).then((res) => {
          if (res) {
            this.$notification.success({
              message: "Registration Successful",
              description:
                "Thanks for being the member of Khaanpin family. Login to continue.",
            });
          } else {
            this.$notification.error({
              message: "Registration Fail",
              description: "Please try again",
            });
          }
        });
      }

      this.firstnameError = "";
      this.lastnameError = "";
      this.phoneError = "";
      this.emailError = "";
      this.passwordError = "";
      this.addressError = "";

      if (!this.first_name) {
        this.firstnameError = "First Name is required";
        this.boolfirstnameError = !this.boolfirstnameError;
      }
      if (!this.last_name) {
        this.lastnameError = "Last Name is required";
        this.boollastnameError = true;
      }
      if (!this.phone) {
        this.boolphoneError = true;
        this.phoneError = "Phone Number is required";
      }
      if (!this.email) {
        this.boolemailError = true;
        this.emailError = "Email is required";
      }
      if (!this.password) {
        this.boolpasswordError = true;
        this.passwordError = "Password is required";
      }
      if (!this.address) {
        this.booladdressError = true;
        this.addressError = "Address is required";
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.signup__main {
  /* border: 1px solid red; */
  display: flex;
  font-family: "Montserrat", sans-serif;
  background-color: #f2f2f2;
}

.signup__col1 {
  flex: 6;
  /* background-color: #f2f2f2; */
  background: url("../../assets/background/login.jpg") repeat-x;

  background-size: contain;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
}

.signup__back {
  position: absolute;
  top: 2%;
  left: 2%;
  color: #ed3c3b;
  cursor: pointer;
}

.signup__back > img {
  height: 35px;
}

.signup__col1Body {
  /* border: 1px solid black; */
  padding: 10% 16%;
  background-color: #ffffff;
  border-radius: 12px;
  position: relative;
}

.signup__col2 {
  flex: 6;
  /* background-color: green; */
  min-height: 100vh;
  box-shadow: 0 3px 6px #00000029, 0 3px 6px #0000003b;
}

.signup__col2 > img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  box-shadow: 0 0 8px 0 rgb(0 0 0 / 10%);
}

.signup__header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.signup__subHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: black;
}

.signup__header > img {
  height: 100px;
}

.signup__header > span {
  font-size: 25px;
  font-weight: bolder;
}

.signup__body {
  display: flex;
  flex-direction: column;
  margin: 6% 0;
}

.signup__input {
  display: flex;
  align-items: center;
  width: 20rem;
  margin-bottom: 15px;
  padding: 0.8em 0;
  border: 1px solid #808080;
  border-radius: 12px;
  background-color: #ffffff !important;
}

.signup__input > input {
  border: none;
  outline: none;
  width: 23rem;
  padding-left: 10px;
}

.signup__body > button {
  background-color: #ed3c3b;
  color: white;
  border: none;
  padding: 15px 0;
  border-radius: 12px;
  font-weight: bolder;
  transition: 0.3s all;
  margin-top: 15px;
}

.signup__body > button:hover {
  background-color: #c20b0b;
  cursor: pointer;
}

.signup__body > input {
  /* outline:none; */
  width: 29rem;
  margin-bottom: 15px;
  padding: 0.8em 8px;
  border: 1px solid #808080;
  border-radius: 12px;
  background-color: #ffffff !important;
  outline: none;
}

::placeholder {
  color: grey;
  /* text-align: center; */
}

.signup__loc {
  /* border: 1px solid black; */
  text-align: center;
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.signup__loc > span:nth-child(1) {
  margin-right: 5px;
}

.signup__loc > span:nth-child(1):hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}

.signup__loc > span:nth-child(3) {
  margin-left: 5px;
}

.signup__loc > span:nth-child(3):hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}

@media only screen and (max-width: 1250px) {
  .signup__col2 {
    display: none;
  }

  .signup__col1Body {
    /* border: 1px solid black; */
    padding: 10% 16%;
    background-color: #ffffff;
    border-radius: 12px;
    position: relative;
  }
}

@media only screen and (max-width: 650px) {
  .signup__col1 {
    background: url("../../assets/background/login.jpg") repeat-x;
    background-size: cover;
  }

  .signup__col1Body {
    /* border: 1px solid black; */
    padding: 4% 10%;
    background-color: #ffffff;
    border-radius: 12px;
    /* position: relative; */
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .signup__input {
    /* outline: none; */
    width: 15rem;
    margin-bottom: 18px;
  }

  .signup__button {
    margin-bottom: 15px;
  }

  .signup__body > button {
    margin-bottom: 18px;
  }
  .signup__header > img {
    height: 66px;
  }
}
</style>
